import { render, staticRenderFns } from "./FCellPhone.vue?vue&type=template&id=078e8485&"
import script from "./FCellPhone.vue?vue&type=script&lang=ts&"
export * from "./FCellPhone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports